module.exports = __webpack_public_path__ + "static/media/3.11baa396.png";